import type { JSX } from 'react';

interface WebhooksLimitsNoticeProps {
  limits: { PROJECT_LEVEL: number; SUBPROJECT_LEVEL: number };
}

const WebhooksLimitsNotice = ({ limits }: WebhooksLimitsNoticeProps): JSX.Element => {
  return (
    <div className="mt-4 rounded-lg border border-border-subtle bg-bg-surface px-3 py-2 text-sm text-text-muted font-body">
      <p className="m-0">
        Límites de webhooks: <span className="font-medium text-text-default">{limits.PROJECT_LEVEL}</span> por proyecto
        principal, <span className="font-medium text-text-default">{limits.SUBPROJECT_LEVEL}</span> por subproyecto
      </p>
    </div>
  );
};

export default WebhooksLimitsNotice;
